export const URL_AUTH = "http://35.198.168.127/";

export const URL_PRODUCTION = "https://nuevosistema.busmen.net/WS/";

export const URL_API = `${URL_AUTH}busmen/`;
export const ROOT_ALERT_COMPONENT = 'root-alert-comonent';
export const ROOT_LOAD_COMPONENT = 'load-page';
export const COMPONENTE_ALERT = "this-area-to-alerts";
export const COMPONENT_LOAD = "this-area-to-loadin";

export const NAME_FILE = {
      logIn: "logIn-preodt",
      unid: "pre-orden",
      mechanical : "mecanico",
      almacen: "almacen",
}

export const TEXT_ALERT = {
      problem: "Ocurrió un problema. Inténtalo más tarde o ponte en contacto con el departamento de sistemas",
      empy: "Ningún campo debe quedar en blanco"
}

// #region PRE ORDEN
export const TEXT_PRE_ORDEN = {
      tf_user: "Correo / usuario",
      tf_pwd: "Contraseña"
}

export const TYPE_TF_PO = {
      unidad: "unidad",
      chofer: "chofer",
      desc: "description"
}

export const TT_TEXT_PO = {
      pre_order: "Reportar unidad averiada",
      confirm: "Confirmar entrada al taller",
      work_order: "Crear orden de trabajo",
      map_mechanical: "Vista general de los talleres",
      calendar: "Calendario de trabajo de los talleres",
      manual:"Manuales de unidades",
      diagram: "Buscar diagrama",
      chat: "Chat de ayuda para mecanicos"

}

export const TEXT_REPORT_PO = {
      title: "Reporte de fallas",
      unit: "Selecciona el camión que tiene la falla",
      chofer: "Selecciona el chofer que levanta el reporte",
      description: "Describe la falla de la unidad",
}

// #endregion PRE ORDEN

// #endregion CONFIRMATION ORDER
export const TEXT_REPORT_CO = {
      title: 'Reportes hechos',
      columnTable : [
            { headerName: 'ID', field: 'id', flex: 1 },
            // { headerName: 'Status', field: 'status', flex: 1 },
            { headerName: 'Nombre Chofer', field: 'datosChofer.label', flex: 1 },
            { headerName: 'Unidad', field: 'datosUnidad.label', flex: 1 },
            { headerName: 'Descripcion', field: 'descripcion', flex: 1 },
      ],
}

export const TYPE_TF_CO ={
      servicio: "servicio",
      date: "date",
      taller: "taller",
      mecanico_1 : "mecanico_1",
      mecanico_2: "mecanico_2"
}
// #endregion CONFIRMATION ORDER

// # region WORK ORDER

export const TEXT_REPORT_WO = {
      title: 'Órdenes agendadas',
}
// # endregion WORK ORDER

// # region CALENDAR
export const TEXT_REPORT_CAL = {
      title: 'Calendario de trabajo Taller 1',
      subtitle: "Total de naves : 4 | capacidad maxima: 50"
}
// # endregion CALENDAR

export const TEXT_BTN = {
      accepted: "Aceptar",
      cancel: "Cancelar",
      exit: "Salir",
      clear: "Limpiar",
}

export const DATA_USER ={
      user: 'user_id',
      pws: 'password'
}

export const TYPES_ALERTS={
      error:'error',
      warning:'warning',
      info:'info',
      success:'success'

}


export const INIT_DATA_USER ={
      [DATA_USER.user]: '',
      [DATA_USER.pws]: ''
}

export const KEYS_QUERYS = {
      user: "user",
      pwd: "contrasena"
}

export const TYPE_THEME = {
      light: "light",
      dark: "dark",
      mode: "theme_mode"
}

export const TYPE_THEME_AG_GRID = {
      light: "ag-theme-balham",
      dark: "ag-theme-balham-dark"
}


export const COLORS ={
      black: "rgb(255,255,255)",
      white: "rgb(0,0,0)",
      red: "rgb(255,0,0)",
      green: "rgb(0,255,0)",
      blue: "rgb(33, 150, 243)",
      blue_t1: "rgb(13,70,180)",
      lightblue: 'rgb(150, 222, 209)',
      yellow: 'rgb(255, 255, 102)',
      ligth : {
            background: "rgb(255,255,255)",
            title: 'rgb(51, 51, 51)',
            subtitle: 'rgb(51, 51, 51)',
            head: 'rgb(68, 68, 68)',
      },
      dark: {
            background: 'rgb(51, 51, 51)',
            title: 'rgb(255, 255, 255)',
            subtitle: 'rgb(255, 255, 255)',
            head: 'rgb(204, 204, 204)',
      }
}

// # Region TYPE API
export const TYPE_REQUEST = {
      GET: "GET",
      POST: "POST",
      PUT: "PUT",
      DELETE: "DELETE"
}